// @flow

import type {Channel} from "./Objects";

let channelOrder = {
  "tpt2": 0,
  "tpt 2": 1,
  "tptmn": 2,
  "tpt mn": 3,
  "tptlife": 4,
  "tpt life": 5,
  "tptkids": 6,
  "tpt kids": 7
};

export function getChannelIndex(channel: string): number {
  switch(channel) {
    case 'TPT2':
      return 0;
    case 'TPTMN':
      return 1;
    case 'TPTLIFE':
      return 2;
    case 'TPTKIDS':
      return 3;
  }

  return -1;
}

export function sortChannels(channels: Array<Channel>): Array<Channel> {
  let c2 = channels.slice();
  c2.sort((a, b) => {
    return channelOrder[a.toLowerCase()] - channelOrder[b.toLowerCase()];
  });
  return c2;
}

export function channelDisplayName(channel: Channel): string {
  switch(channel) {
    case "TPT2":
      return "TPT 2";
    case "TPTMN":
      return "TPT MN";
    case "TPTLIFE":
      return "TPT Life";
    case "TPTKIDS":
      return "PBS Kids";
    case "TPTNOW":
      return "TPT Now";
  }

  return "";
}